import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon, ArrowLeftIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
export const KnowledgeBaseGettingStarted = () => {
  const {
    theme
  } = useTheme();
  const darkMode = theme === 'dark';
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    question: 'What is Maestro Connect?',
    answer: "Maestro Connect is a platform that helps music teachers and students manage lessons, schedules, and communication in one place. It's designed to simplify private music education and keep everything organized."
  }, {
    question: 'How do I sign up?',
    answer: "Click Sign Up and choose whether you are a teacher or a student. Follow the steps to create your account. Once verified, you'll be taken to your dashboard."
  }, {
    question: "What's the difference between a teacher and a student account?",
    answer: 'Teacher accounts are used to manage students, lessons, schedules, and tasks. Student accounts are used to view lessons, receive assignments, and track progress.'
  }, {
    question: 'How do lessons work?',
    answer: 'Teachers create and schedule lessons. Students join lessons that are assigned to them. All lesson details appear in your calendar and dashboard.'
  }, {
    question: "Where can I get help if I'm stuck?",
    answer: 'You can contact support by email or browse the Help & Support section for answers to common questions. We typically respond within 24 hours.'
  }];
  return <main className="pb-6" data-id="element-4948">
      <div className="max-w-4xl mx-auto px-4" data-id="element-4949">
        {/* Back button */}
        <button onClick={() => navigate('/help-support')} className={`flex items-center mb-6 ${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-4950">
          <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-4951" />
          Back to Help & Support
        </button>

        {/* Header */}
        <div className="mb-8" data-id="element-4952">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2" data-id="element-4953">
            Getting Started
          </h1>
          <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-4954">
            Learn the basics of using Maestro Connect
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3" data-id="element-4955">
          {faqs.map((faq, index) => <div key={index} className={`rounded-lg overflow-hidden ${darkMode ? 'bg-navy-800' : 'bg-white'} shadow-sm`} data-id="element-4956">
              <button className={`w-full px-6 py-4 text-left flex justify-between items-center hover:${darkMode ? 'bg-navy-700' : 'bg-gray-50'} transition-colors`} onClick={() => toggleFaq(index)} data-id="element-4957">
                <span className={`font-medium text-lg ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-4958">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`h-5 w-5 ${darkMode ? 'text-gray-400' : 'text-gray-500'} transition-transform flex-shrink-0 ml-4 ${openFaq === index ? 'transform rotate-180' : ''}`} data-id="element-4959" />
              </button>
              {openFaq === index && <div className={`px-6 py-4 ${darkMode ? 'border-t border-navy-700' : 'border-t border-gray-200'}`} data-id="element-4960">
                  <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} leading-relaxed`} data-id="element-4961">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </main>;
};